/**
 * @file hooks/useAuditorOptions.ts
 * @description 稽核員候選名單查詢 hook（供利益迴避等表單「稽核員下拉」共用）。
 *
 * 後端端點：GET /api/settings/conflict-of-interest/auditor-options
 * （conflict-of-interest.manage，admin/manager 皆可讀；回傳在職 auditor 員工）
 * 數量級小，一次性拉回 + TanStack Query 5 分鐘快取，前端 Select 內過濾。
 */

import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';

/** 稽核員下拉選項所需的最小欄位 */
export interface AuditorOption {
  /** 用戶 ID（主鍵，選中後存此值） */
  id: number;
  /** 員工姓名 */
  name: string;
  /** 用戶名（可選顯示） */
  username?: string | null;
}

/** 後端回應結構 */
interface AuditorOptionsResponse {
  items: AuditorOption[];
}

/** 共用 query key，方便手動 invalidate */
export const AUDITOR_OPTIONS_QUERY_KEY = ['auditor-options-lookup'] as const;

/**
 * 取得稽核員候選名單（在職且具 auditor 角色）。
 */
export function useAuditorOptions(enabled = true) {
  return useQuery({
    queryKey: AUDITOR_OPTIONS_QUERY_KEY,
    queryFn: () =>
      apiClient.get<AuditorOptionsResponse>('/api/settings/conflict-of-interest/auditor-options'),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
